import { render, staticRenderFns } from "./tzproduct9.vue?vue&type=template&id=73bf8130&scoped=true"
import script from "./tzproduct9.vue?vue&type=script&lang=js"
export * from "./tzproduct9.vue?vue&type=script&lang=js"
import style0 from "./tzproduct9.vue?vue&type=style&index=0&id=73bf8130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf8130",
  null
  
)

export default component.exports